import type { RouteObject } from "react-router-dom";
import { DevicesList, DevicesDetails } from "@admin/pages/devices";

const routes = [
  { index: true, element: <DevicesList /> },
  { path: ":id", element: <DevicesDetails /> },
  // { path: "details", element: <DevicesDetails /> },
  // { path: ":identity/events", element: <EventsList /> },
  // { path: ":identity/events/:id", element: <EventsDetail /> },
] satisfies RouteObject[];

export const devicesRoute = {
  path: "/devices",
  children: routes,
} satisfies RouteObject;
